import React from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';

import { percentageBarColorClassNames, PercentageBarColorT } from './NcPercentageBar';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/draw-request/percentage-bar-color-pill.scss';

export type NcPercentageBarColorPillPropsT = {
  color: PercentageBarColorT;
};
export type NcPercentageBarColorPillT = React.FC<NcPercentageBarColorPillPropsT>;

export const NcPercentageBarColorPill: NcPercentageBarColorPillT = ({ color }) => (
  <span
    aria-hidden="true"
    className={mergeClassNameStrings('nc-percentage-bar-color-pill', percentageBarColorClassNames[color])}
    role="presentation"
  />
);
